import React, { useEffect, useState } from "react";
import { folkApi } from "../lib/api";
import { Users2, X } from "lucide-react";
import { toast } from "sonner";

// Push the selected CRM rows into a folk group — one group per deal per list by default.
export const SendToFolkModal = ({ open, onClose, source, label, ids = [], contacts = [], dealName = "" }) => {
  const suggested = dealName ? `${dealName} — ${label}` : label;
  const [groupName, setGroupName] = useState(suggested);
  const [groups, setGroups] = useState([]);
  const [busy, setBusy] = useState(false);
  const [report, setReport] = useState(null);
  // Same dedupe the server applies, so the button never promises more than it sends.
  const count = new Set([...ids, ...contacts.filter((c) => c.email).map((c) => c.email.trim().toLowerCase())]).size;

  useEffect(() => {
    if (!open) return;
    setGroupName(suggested); setReport(null);
    folkApi.groups().then((r) => setGroups(r.groups || [])).catch(() => setGroups([]));
  }, [open, suggested]);

  if (!open) return null;

  const send = async () => {
    setBusy(true);
    try {
      const res = await folkApi.sync({ source, ids, contacts, dealName, groupName });
      setReport(res);
      toast.success(`folk · ${res.created} added, ${res.updated} updated in “${res.group.name}”`);
    } catch (e) { toast.error(e?.response?.data?.detail || "folk sync failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="modal-overlay" data-testid="folk-modal" onMouseDown={onClose} style={{ zIndex: 92 }}>
      <div className="modal-card" style={{ maxWidth: 560, width: "94%" }} onMouseDown={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
          <div className="modal-title" style={{ marginBottom: 0 }}><Users2 size={14} style={{ marginRight: 6 }} />Send to folk</div>
          <button className="btn btn-sm" onClick={onClose} data-testid="folk-close"><X size={14} /></button>
        </div>
        <div className="modal-sub">{count.toLocaleString()} selected from {label} go into a folk group. Anyone already in folk keeps their existing groups, company and notes. Large pushes take a second or two per contact.</div>

        <div className="field" style={{ marginTop: 12 }}>
          <label>folk group</label>
          <input className="inp inp-text" value={groupName} onChange={(e) => setGroupName(e.target.value)} data-testid="folk-group-name" />
        </div>
        {groups.length ? (
          <div className="field" style={{ marginTop: 8 }}>
            <label>…or pick one you already have</label>
            <select className="inp" value="" onChange={(e) => e.target.value && setGroupName(e.target.value)} data-testid="folk-group-pick">
              <option value="">Existing groups ({groups.length})</option>
              {groups.map((g) => <option key={g.id} value={g.name}>{g.name}</option>)}
            </select>
          </div>
        ) : null}

        {report ? (
          <div className="banner info" style={{ marginTop: 12 }} data-testid="folk-report">
            <b>{report.group.name}</b> · {report.created} added · {report.updated} updated
            {report.failed ? ` · ${report.failed} failed` : ""}{report.skipped?.length ? ` · ${report.skipped.length} skipped (no email)` : ""}
          </div>
        ) : null}

        <button className="btn btn-primary" style={{ width: "100%", marginTop: 12 }} disabled={busy || !groupName.trim() || !count} onClick={send} data-testid="folk-send">
          {busy ? "Sending to folk…" : `Send ${count.toLocaleString()} to folk`}
        </button>
      </div>
    </div>
  );
};
